import React from 'react';
import { resetPassword } from 'services/clients/user';
import { CircularProgress } from '@mui/material';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useSelector } from 'react-redux';

export const ChangePasswordButton: React.FC = () => {
  const [state, setState] = React.useState({
    isLoading: false,
    emailSent: false,
    error: false,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const email: string = useSelector((s: any) => s.user.email);

  const changePassword = React.useCallback(() => {
    setState((s) => ({ ...s, isLoading: true }));
    resetPassword({ email })
      .then(() => setState({ isLoading: false, emailSent: true, error: false }))
      .catch(() => setState({ isLoading: false, emailSent: false, error: true }));
  }, [email]);

  const { isLoading, emailSent, error } = state;

  if (emailSent)
    return (
      <div className="text-green-700 flex items-center gap-1">
        <CheckIcon className="h-4" />
        <h4 className="inline">We&apos;ve sent you an email</h4>
      </div>
    );
  if (error)
    return (
      <div className="text-red-500 flex items-center gap-1">
        <XMarkIcon className="h-4" />
        <h4 className="inline">Unable to change your password</h4>
      </div>
    );

  return (
    <h4 className="underline text-gray-500 cursor-pointer" onClick={changePassword}>
      {isLoading ? <CircularProgress color="secondary" size={20} /> : 'Reset password'}
    </h4>
  );
};
ChangePasswordButton.displayName = 'Settings.Profile.ChangePasswordButton';
